export default function IconAdd() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.7508 2.92969C10.7508 2.51547 10.415 2.17969 10.0008 2.17969C9.58654 2.17969 9.25075 2.51547 9.25075 2.92969V9.25075H2.92969C2.51547 9.25075 2.17969 9.58654 2.17969 10.0008C2.17969 10.415 2.51547 10.7508 2.92969 10.7508H9.25075V17.0718C9.25075 17.486 9.58654 17.8218 10.0008 17.8218C10.415 17.8218 10.7508 17.486 10.7508 17.0718V10.7508H17.0718C17.486 10.7508 17.8218 10.415 17.8218 10.0008C17.8218 9.58654 17.486 9.25075 17.0718 9.25075H10.7508V2.92969Z"
                fill="currentColor"
            />
        </svg>
    );
}
